import { render, staticRenderFns } from "./create-job.vue?vue&type=template&id=53040104&"
import script from "./create-job.vue?vue&type=script&lang=js&"
export * from "./create-job.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports